import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import withHandlers from 'recompose/withHandlers';
import withState from 'recompose/withState';
import { getPrismicProductByLocale } from '../../../store/selectors/prismic/product';
import { connect } from 'react-redux';
import {
  isLoading,
  getPages,
  buildPreviewPages,
  getNavItems,
  updateBookPreviewPages,
  setIsBookPreviewHeidelberg,
  isHeidelberg,
  setBookPreviewActivePage,
  getActivePage,
  setBookPreviewImageWidth,
  getImageWidth,
  getScrollAmount,
  setBookPreviewScroll,
  getBookPreviewUrlsFailure,
} from './duck';
import product from 'src/common/config/product';
import BookPreview from './BookPreview';
import { parseQuery, hasInsideCovers, getBreadCrumbType } from './helpers';
import withMedia from 'src/client/js/view/hocs/withMediaQueries';
import withProductCustomisation from '../../hocs/withProductCustomisation';
import { getCompletedDrawer } from '../CanvasDrawers/duck';

const enhance = compose(
  withProductCustomisation,
  connect(
    (state, props) => ({
      isLoading: isLoading(state),
      pages: getPages(state),
      navItems: getNavItems(state),
      isHeidelberg: isHeidelberg(state),
      activePage: getActivePage(state),
      imageWidth: getImageWidth(state),
      scrollPosition: getScrollAmount(state),
      prismicProduct: getPrismicProductByLocale(state, props.productId, props.productCustomisation.locale),
      completedDrawer: getCompletedDrawer(state),
    }),
    dispatch => ({
      setScrollPosition: scrollAmount => dispatch(setBookPreviewScroll(scrollAmount)),
      buildPreviewPages: options => dispatch(buildPreviewPages(options)),
      sendPreviewFailure: error => dispatch(getBookPreviewUrlsFailure(error)),
      updateBookPreviewPages: pages => dispatch(updateBookPreviewPages(pages)),
      setIsHeidelberg: isHeidelberg => dispatch(setIsBookPreviewHeidelberg(isHeidelberg)),
      setActivePage: activePage => dispatch(setBookPreviewActivePage(activePage)),
      setBookPreviewImageWidth: imageWidth => dispatch(setBookPreviewImageWidth(imageWidth))
    }),
  ),
  withProps(props => {
    const currentProduct = product.getProductByKey(props.productKey);
    const ratio = currentProduct.dimensions.height / currentProduct.dimensions.width;
    let multiplier = 50;
    if (ratio === 1) {
      multiplier = 40;
    } else if (ratio > 1) {
      multiplier = 35;
    }
    return {
      padding: props.isHeidelberg ? ratio * multiplier : 0,
      query: parseQuery(props.location.search),
      multiplier,
      hasInsideCovers: hasInsideCovers(currentProduct.sku),
      hasCharacterPicker: getBreadCrumbType(currentProduct.sku) === 'character-picker',
      hasBreadCrumb: getBreadCrumbType(currentProduct.sku, props.breadcrumbs) === 'breadcrumb',
      sortBreadcrumbs: props.sortBreadcrumbs === 'true',
    };
  }),
  withHandlers((props) => ({
    calculatePreviewImageWidth: props => () => {
      props.setBookPreviewImageWidth(window.innerWidth * 0.75);
    }
  })),
  withState('transform', 'setTransform', null),
  withState('needsTransform', 'setNeedsTransform', false),
  withMedia,
);

export default enhance(BookPreview);



// WEBPACK FOOTER //
// ./src/client/js/view/components/BookPreview/index.js